// import { watch } from 'vue';
// на выходе данные массив обьектов содержашиеся в this.selectedUsers

import { mapGetters, mapMutations, mapState } from 'vuex';

export default {
  data() {
    return {
      // selectedUsers: [],
      // selectedUsers_elem: []
    };
  },
  computed: {
    isAllSelected() {
      return this.members_id.length === this.totalUsersCount();
    },
    ...mapState({
      members: state => state.modalUsers.members,
      members_id: state => state.modalUsers.members_id
    })
  },
  methods: {
    ...mapMutations({
      SET_MEMBERS_ID: 'modalUsers/SET_MEMBERS_ID',
      PYSH_MEMBERS_ID: 'modalUsers/PYSH_MEMBERS_ID',
      SET_MEMBERS: 'modalUsers/SET_MEMBERS',
      PYSH_MEMBERS: 'modalUsers/PYSH_MEMBERS',
      FILTER_AND_REMOVE_MEMBER: 'modalUsers/FILTER_AND_REMOVE_MEMBER',
      FILTER_AND_REMOVE_MEMBER_ID: 'modalUsers/FILTER_AND_REMOVE_MEMBER_ID'
    }),
    totalUsersCount() {
      // Вспомогательный метод для получения общего количества пользователей
      return this.users.reduce((total, group) => total + group.length, 0);
    },
    isSelected(userId) {
      // Проверяем, выбран ли пользователь по его айдишнику
      return this.members_id.includes(Number(userId.user_id));
    },
    selectAll() {
      // Обработчик для выбора всех пользователей
      if (this.isAllSelected) {
        this.SET_MEMBERS_ID([]);
        this.SET_MEMBERS([]);
      } else {
        const members_id = this.users.reduce(
          (allUsers, group) =>
            allUsers.concat(group.map(user => Number(user.user_id))),
          []
        );
        const members = this.users.reduce(
          (allUsers, group) => allUsers.concat(group.map(user => user)),
          []
        );
        this.SET_MEMBERS_ID(members_id);
        this.SET_MEMBERS(members);
      }
    },
    isGroupSelected(group) {
      // Проверяем, выбраны ли все пользователи в группе
      return group.every(user =>
        this.members_id.includes(Number(user.user_id))
      );
    },
    selectGroup(group) {
      // Обработчик для выбора всех пользователей в группе
      if (this.isGroupSelected(group)) {
        const members_id = this.members_id.filter(
          userId => !group.some(user => Number(user.user_id) === Number(userId))
        );
        const members = this.members.filter(
          userId =>
            !group.some(user => Number(user.user_id) === Number(userId.user_id))
        );
        this.SET_MEMBERS_ID(members_id);
        this.SET_MEMBERS(members);
      } else {
        const members_id = this.members_id.concat(
          group
            .filter(user => !this.members_id.includes(Number(user.user_id)))
            .map(user => Number(user.user_id))
        );

        const members = this.members.concat(
          group
            .filter(
              user =>
                !this.members.some(member => member.user_id === user.user_id)
            )
            .map(user => ({ ...user })) // Копируем объекты для создания новых ссылок
        );

        this.SET_MEMBERS_ID(members_id);
        this.SET_MEMBERS(members);
      }
    },
    selectUser(userId) {
      // Обработчик для выбора отдельного пользователя
      if (this.isSelected(userId)) {
        console.log(userId, 'selectUser');
        this.FILTER_AND_REMOVE_MEMBER(Number(userId.user_id));
        this.FILTER_AND_REMOVE_MEMBER_ID(Number(userId.user_id));
      } else {
        this.PYSH_MEMBERS_ID(userId.user_id);
        this.PYSH_MEMBERS(userId);
      }
    }
  }
};
